// @flow

import { observable, runInAction, configure, action } from 'mobx';
import companiesApi from 'api/companies.api';

configure({ enforceActions: 'observed' });

class CompanyStatisticsStore {
  @observable loading: boolean = false;
  @observable company: any = {};

  @action.bound
  async setCompany(id: string) {
    this.loading = true;
    const { data } = await companiesApi.get(id, { include: '', fields: { companies: 'name,statistics' } });

    runInAction(() => {
      this.loading = false;
      this.company = data;
    });
  }
}

export default new CompanyStatisticsStore();
